module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2018_09.f077a539.jpg";